import { useState } from 'react'
import Modal from '@components/Modal'
import { withTranslate } from '@i18n/utils'

let resolveCallback
const useConfirm = () => {
    const [show, setShow] = useState(false)

    const confirm = () =>
        new Promise(resolve => {
            resolveCallback = resolve
            setShow(true)
        })

    const onConfirm = () => {
        resolveCallback(true)
        setShow(false)
    }

    const onCancel = () => {
        resolveCallback(false)
        setShow(false)
    }

    const ConfirmModal = withTranslate(({ buttonsText = {}, title, text, translate: t }) => {
        if (show) {
            return (
                <Modal
                    onClose={onCancel}
                    header={t(title)}
                    buttons={[
                        {
                            label: t(buttonsText.cancel || 'confirmation.hook.modal.btn.cancel'),
                            onClick: onCancel,
                            btnStyle: 'outline',
                        },
                        {
                            label: t(buttonsText.confirm || 'confirmation.hook.modal.btn.ok'),
                            onClick: onConfirm,
                        },
                    ]}>
                    <p className="mb-4">
                        <T>{text}</T>
                    </p>
                </Modal>
            )
        }

        return null
    })

    return { show, confirm, onConfirm, onCancel, ConfirmModal }
}

export { useConfirm }
